import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import useMediaQuery from '@hellodarwin/core/lib/features/helpers/use-media-query';
import AddNew from '@hellodarwin/icons/dist/icons/AddNew';
import { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useTheme } from 'styled-components';
import { useConversation } from '../../hooks';
import { useAssistantApi } from '../../hooks/useAssistantApi';
import { useAssistantContext } from '../../providers';
import { useAssistantDispatch, useAssistantSelector, } from '../../redux/assistant-hooks';
import { fetchConversations } from '../../redux/assistantConversationSlice';
import { selectScopedConversations } from '../../redux/selectors';
import AssistantSiderConversations from './AssistantConversationsList';
import AssistantSiderLink from './AssistantSiderLink';
import AssistantSiderWrapper from './AssistantSiderWrapper';
import { AssistantSiderBody, AssistantSiderCollapsedActionStack, AssistantSiderCollapsedContent, AssistantSiderLinkCountBadge, } from './styles';
const AssistantSider = ({ onStartNewConversation, }) => {
    var _a, _b, _c;
    const { t } = useTranslation();
    const theme = useTheme();
    const dispatch = useAssistantDispatch();
    const assistantApi = useAssistantApi();
    const { activeConversation } = useConversation();
    const { createConversation, usageContext } = useAssistantContext();
    const scopedCompanyId = (_a = usageContext === null || usageContext === void 0 ? void 0 : usageContext.company_id) !== null && _a !== void 0 ? _a : null;
    const scopedGrantApplicationId = (_b = usageContext === null || usageContext === void 0 ? void 0 : usageContext.grant_application_id) !== null && _b !== void 0 ? _b : null;
    const scopedEOSAccountabilityChartId = (_c = usageContext === null || usageContext === void 0 ? void 0 : usageContext.eos_accountability_chart_id) !== null && _c !== void 0 ? _c : null;
    const conversations = useAssistantSelector((state) => selectScopedConversations(state, scopedCompanyId, scopedGrantApplicationId, scopedEOSAccountabilityChartId));
    const conversationsStatus = useAssistantSelector((state) => state.conversations.status);
    const isSmallDesktop = useMediaQuery({ maxWidth: theme.breakpoints.md });
    const [isOpen, setIsOpen] = useState(!isSmallDesktop);
    useEffect(() => {
        if (isSmallDesktop) {
            setIsOpen(false);
        }
    }, [activeConversation === null || activeConversation === void 0 ? void 0 : activeConversation.id, isSmallDesktop]);
    useEffect(() => {
        if (!isSmallDesktop) {
            setIsOpen(true);
        }
    }, [isSmallDesktop]);
    useEffect(() => {
        if (conversationsStatus === 'idle') {
            dispatch(fetchConversations({ api: assistantApi }));
        }
    }, [assistantApi, conversationsStatus, dispatch]);
    const handleCreateNewConversation = useCallback(() => {
        if (onStartNewConversation) {
            onStartNewConversation();
            return;
        }
        createConversation();
    }, [createConversation, onStartNewConversation]);
    const collapsedBadgeLabel = conversations.length > 99 ? '99+' : conversations.length;
    return (_jsx(AssistantSiderWrapper, { setIsOpen: setIsOpen, isOpen: isOpen, onCreateConversation: handleCreateNewConversation, children: _jsxs(AssistantSiderBody, { children: [!isOpen && (_jsx(AssistantSiderCollapsedContent, { children: _jsxs(AssistantSiderCollapsedActionStack, { children: [_jsx(AssistantSiderLink, { label: t('assistant|create_conversation'), onClick: handleCreateNewConversation, Icon: AddNew }), conversationsStatus === 'succeeded' && (_jsx(AssistantSiderLinkCountBadge, { children: collapsedBadgeLabel }))] }) })), isOpen && _jsx(AssistantSiderConversations, {})] }) }));
};
export default AssistantSider;
